// extracted by mini-css-extract-plugin
export default {"particleCanvas":"InteractiveEffects_particleCanvas__xpPnx"};